/* Elegance Coque — boutons des cartes produits : « AJOUTER AU PANIER » puis « ACHETER MAINTENANT » (l'un sous l'autre).
   Les deux prennent le modèle d'iPhone mémorisé (si la coque existe pour lui) et la couleur choisie sur la carte ;
   si la variante est complète et disponible, l'action est immédiate ; sinon le panneau de choix s'ouvre
   (modèle d'iPhone et variante obligatoires). Jamais d'autre modèle ajouté automatiquement.
   AJOUTER AU PANIER → ajout puis panier latéral (assets/ec-buy.js).
   ACHETER MAINTENANT → formulaire de commande paiement à la livraison (ECBuy.buyNow). */
(function () {
  if (window.ECCardActions) { return; }
  var d = document, W = window;
  var MODEL_OPT = 'Modèle iPhone';
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var CACHE = {};
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var BOLT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M13 3L5 13h6l-1 8 8-10h-6l1-8z"/></svg>';
  var CARDS = '.lcard,.ec-p,.lwl-card';

  /* ---------- outils ---------- */
  function qa(r, s) { return [].slice.call((r || d).querySelectorAll(s)); }
  function esc(t) { var s = d.createElement('span'); s.textContent = t == null ? '' : String(t); return s.innerHTML; }
  function dh(c) { c = Math.round(Number(c) || 0); var w = Math.floor(c / 100), r = c % 100; return String(w).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (r ? ',' + (r < 10 ? '0' : '') + r : '') + ' DH'; }
  function handleOf(u) { var m = String(u || '').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function optNames(p) { return (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; }); }
  function valHandle(v) { return 'iphone-' + String(v || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function storedModel() {
    if (W.ECModel) { var m = W.ECModel.read(); return m ? m.handle : ''; }
    try { var v = W.localStorage.getItem('ec-model') || ''; return v.split('|')[0]; } catch (e) { return ''; }
  }
  function saveModel(val) {
    var m = { handle: valHandle(val), label: 'iPhone ' + val };
    if (W.ECModel) { W.ECModel.save(m); return; }
    try { W.localStorage.setItem('ec-model', m.handle + '|' + m.label); } catch (e) {}
  }
  function getProduct(h) {
    if (!CACHE[h]) {
      CACHE[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) { throw new Error('p'); } return r.json(); })
        .catch(function (e) { delete CACHE[h]; throw e; });
    }
    return CACHE[h];
  }

  /* ---------- toast (messages d'erreur) ---------- */
  var toastT = 0;
  function toast(html) {
    var t = d.querySelector('.ecca-toast');
    if (!t) { t = d.createElement('div'); t.className = 'ecca-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); d.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('is-on');
    W.clearTimeout(toastT); toastT = W.setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  /* ---------- boutons sur les cartes construites sans le snippet ---------- */
  function rowHtml(h, url, title, sold) {
    return '<div class="ecca" data-ecca data-handle="' + esc(h) + '" data-url="' + esc(url) + '" data-title="' + esc(title) + '">' +
      '<button type="button" class="ecca__add" data-ecca-add aria-label="Ajouter ' + esc(title) + ' au panier"' + (sold ? ' disabled' : '') + '>' + BAG + '<span>' + (sold ? 'ÉPUISÉ' : 'AJOUTER AU PANIER') + '</span></button>' +
      (sold ? '' : '<button type="button" class="ecca__buy" data-ecca-buy aria-label="Acheter ' + esc(title) + ' maintenant">' + BOLT + '<span>ACHETER MAINTENANT</span></button>') +
      '</div>';
  }
  function upgrade(row) {
    /* anciennes lignes « AJOUTER » + partage (cache de page) : ajoute le 2e bouton */
    if (row.querySelector('[data-ecca-buy]')) { return; }
    var add = row.querySelector('[data-ecca-add]'); if (!add) { return; }
    var lbl = add.querySelector('span');
    if (lbl && /^AJOUTER$/i.test(lbl.textContent.trim())) { lbl.textContent = 'AJOUTER AU PANIER'; }
    if (add.disabled) { return; }
    add.insertAdjacentHTML('afterend', '<button type="button" class="ecca__buy" data-ecca-buy aria-label="Acheter ' + esc(row.getAttribute('data-title') || '') + ' maintenant">' + BOLT + '<span>ACHETER MAINTENANT</span></button>');
  }
  function decorate() {
    qa(d, CARDS).forEach(function (card) {
      if (card.querySelector('[data-ecca]') || card.closest('[data-ecca-skip]')) { return; }
      var a = card.querySelector('a[href*="/products/"]'); if (!a) { return; }
      var url = (a.getAttribute('href') || '').split('?')[0], h = handleOf(url); if (!h) { return; }
      var nameEl = card.querySelector('.lcard__name,.ec-p__name,.lwl-card__name');
      var title = nameEl ? nameEl.textContent.trim() : h;
      var sold = !!card.querySelector('.lcard__off,.lwl-card__off');
      card.insertAdjacentHTML('beforeend', rowHtml(h, url, title, sold));
      qa(card, '.ec-p__quick').forEach(function (b) { b.parentNode.removeChild(b); });
    });
    qa(d, '[data-ecca]').forEach(upgrade);
  }

  /* ---------- choix déjà faits sur la carte ---------- */
  function cardColor(row) {
    var card = row.closest(CARDS + ',.luxe-item,li') || row.parentNode;
    var b = card && card.querySelector('.lsw__b[aria-pressed="true"]');
    return b ? (b.getAttribute('data-name') || '') : '';
  }
  function preselect(p, row) {
    var names = optNames(p), sel = names.map(function () { return null; });
    var mi = names.indexOf(MODEL_OPT), ci = -1;
    names.forEach(function (n, i) { if (/^(couleur|color|colour)$/i.test(n)) { ci = i; } });
    function vals(i) { var out = []; p.variants.forEach(function (v) { var x = v.options[i]; if (out.indexOf(x) < 0) { out.push(x); } }); return out; }
    names.forEach(function (n, i) {
      var vs = vals(i);
      if (n === 'Title' && vs.length === 1) { sel[i] = vs[0]; return; }
      if (i === mi) {
        var hh = storedModel();
        var hit = hh ? vs.filter(function (x) { return valHandle(x) === hh; })[0] : null;
        sel[i] = hit || null;               /* jamais un autre modèle que celui du client */
        return;
      }
      if (i === ci) { var c = cardColor(row); if (c && vs.indexOf(c) > -1) { sel[i] = c; return; } }
      if (vs.length === 1 && i !== mi) { sel[i] = vs[0]; }
    });
    return { names: names, sel: sel, mi: mi };
  }
  function variantFor(p, sel) { return p.variants.filter(function (v) { return sel.every(function (x, i) { return x != null && v.options[i] === x; }); })[0] || null; }

  /* ---------- actions ---------- */
  function addToCart(v, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); }
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { throw new Error(j.description || j.message || ''); } return j; }); })
      .then(function () {
        try { d.dispatchEvent(new CustomEvent('lt:cart-changed')); } catch (e) {}
        if (W.ECBuy) { W.ECBuy.open(true); } else { toast('Ajouté au panier ✓ <a href="' + ROOT + 'cart">Voir le panier</a>'); }
      })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); } });
  }
  function buyNow(v, p) {
    if (W.ECBuy) { W.ECBuy.buyNow(v, 1, p && p.url); return Promise.resolve(); }
    location.href = ROOT + 'cart/' + v.id + ':1';
    return Promise.resolve();
  }

  /* ---------- panneau de choix ---------- */
  var dlg = null, cur = null, lastBtn = null;
  function panel() {
    if (dlg) { return dlg; }
    dlg = d.createElement('dialog'); dlg.className = 'ecca-dlg'; dlg.setAttribute('aria-labelledby', 'ecca-t');
    dlg.innerHTML = '<div class="ecca-dlg__in"><button type="button" class="ecca-dlg__x" data-ecca-close aria-label="Fermer"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<div class="ecca-dlg__hd"><img data-ecca-img alt="" width="72" height="90"><div><p class="ecca-dlg__t" id="ecca-t" data-ecca-title></p><p class="ecca-dlg__pr" data-ecca-price></p></div></div>' +
      '<p class="ecca-dlg__note" data-ecca-note hidden></p><div data-ecca-opts></div>' +
      '<p class="ecca-dlg__help"><button type="button" class="ecp-helplink" data-ecp-help>Je ne connais pas mon modèle</button></p>' +
      '<div class="ecca-dlg__sum" data-ecca-sum aria-live="polite"></div><p class="ecca-dlg__msg" data-ecca-msg role="alert"></p>' +
      '<button type="button" class="ecca-dlg__add" data-ecca-confirm></button>' +
      '<a class="ecca-dlg__more" data-ecca-more href="#">Voir la fiche produit</a></div>';
    d.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || (e.target.closest && e.target.closest('[data-ecca-close]'))) { closePanel(); return; }
      var o = e.target.closest && e.target.closest('[data-ecca-opt]');
      if (o && !o.disabled) {
        var i = Number(o.getAttribute('data-i')), val = o.getAttribute('data-v');
        cur.sel[i] = val; if (i === cur.mi) { saveModel(val); cur.note = ''; }
        renderPanel(); return;
      }
      if (e.target.closest && e.target.closest('[data-ecca-confirm]')) { confirmPanel(); }
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closePanel(); });
    return dlg;
  }
  function closePanel() {
    if (!dlg) { return; }
    if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); }
    d.documentElement.classList.remove('ecca-lock');
    if (lastBtn && lastBtn.focus) { try { lastBtn.focus({ preventScroll: true }); } catch (e) {} }
  }
  function openPanel(p, pre, btn, note, mode) {
    var g = panel(); lastBtn = btn;
    cur = { p: p, names: pre.names, sel: pre.sel.slice(), mi: pre.mi, note: note || '', mode: mode || 'add' };
    g.querySelector('[data-ecca-title]').textContent = p.title;
    g.querySelector('[data-ecca-more]').setAttribute('href', p.url || (ROOT + 'products/' + p.handle));
    var cf = g.querySelector('[data-ecca-confirm]');
    cf.innerHTML = cur.mode === 'buy' ? BOLT + '<span>ACHETER MAINTENANT</span>' : BAG + '<span>AJOUTER AU PANIER</span>';
    cf.classList.toggle('is-buy', cur.mode === 'buy');
    renderPanel();
    if (g.showModal) { g.showModal(); } else { g.setAttribute('open', ''); }
    d.documentElement.classList.add('ecca-lock');
    var first = g.querySelector('.ecca-opt:not([disabled])[aria-pressed="false"]') || g.querySelector('[data-ecca-close]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
  }
  function possible(i, val) {
    return cur.p.variants.some(function (v) {
      if (!v.available || v.options[i] !== val) { return false; }
      for (var k = 0; k < cur.names.length; k++) { if (k !== i && cur.sel[k] != null && v.options[k] !== cur.sel[k]) { return false; } }
      return true;
    });
  }
  function renderPanel() {
    var g = dlg, p = cur.p, html = '';
    var order = cur.names.map(function (n, i) { return i; }).sort(function (a, b) { return (a === cur.mi ? 0 : 1) - (b === cur.mi ? 0 : 1); });
    order.forEach(function (i) {
      var n = cur.names[i]; if (n === 'Title') { return; }
      var vs = []; p.variants.forEach(function (v) { if (vs.indexOf(v.options[i]) < 0) { vs.push(v.options[i]); } });
      html += '<fieldset class="ecca-grp"><legend>' + (i === cur.mi ? 'Modèle d’iPhone' : esc(n)) + '</legend><div class="ecca-vals">';
      vs.forEach(function (val) {
        var on = cur.sel[i] === val, ok = possible(i, val);
        html += '<button type="button" class="ecca-opt" data-ecca-opt data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="' + on + '"' + (!ok && !on ? ' disabled' : '') + '>' + esc(i === cur.mi ? 'iPhone ' + val : val) + '</button>';
      });
      html += '</div></fieldset>';
    });
    g.querySelector('[data-ecca-opts]').innerHTML = html;
    var v = variantFor(p, cur.sel), any = v || p.variants.filter(function (x) { return cur.sel.every(function (s, i) { return s == null || x.options[i] === s; }); })[0] || p.variants[0];
    g.querySelector('[data-ecca-price]').textContent = any ? dh(any.price) : '';
    var img = g.querySelector('[data-ecca-img]'), src = (any && any.featured_image && any.featured_image.src) || p.featured_image || '';
    if (src) { src = src.indexOf('//') === 0 ? 'https:' + src : src; img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200'; img.hidden = false; } else { img.hidden = true; }
    var note = g.querySelector('[data-ecca-note]'); note.textContent = cur.note; note.hidden = !cur.note;
    var sum = '';
    if (cur.mi > -1) { sum += '<p>Modèle sélectionné : ' + (cur.sel[cur.mi] ? '<b>iPhone ' + esc(cur.sel[cur.mi]) + '</b>' : '<span class="ecca-todo">à choisir</span>') + '</p>'; }
    cur.names.forEach(function (n, i) { if (i === cur.mi || n === 'Title') { return; } sum += '<p>' + esc(n) + ' : ' + (cur.sel[i] ? '<b>' + esc(cur.sel[i]) + '</b>' : '<span class="ecca-todo">à choisir</span>') + '</p>'; });
    g.querySelector('[data-ecca-sum]').innerHTML = sum;
    g.querySelector('.ecca-dlg__help').hidden = cur.mi < 0;
    var miss = cur.names.filter(function (n, i) { return n !== 'Title' && cur.sel[i] == null; });
    var msg = '';
    if (!miss.length && v && !v.available) { msg = 'Cette version est épuisée : choisissez une autre couleur.'; }
    g.querySelector('[data-ecca-msg]').textContent = msg;
    var add = g.querySelector('[data-ecca-confirm]'); add.disabled = !!miss.length || !v || !v.available;
  }
  function confirmPanel() {
    var v = variantFor(cur.p, cur.sel), msgEl = dlg.querySelector('[data-ecca-msg]'), btn = dlg.querySelector('[data-ecca-confirm]');
    if (!v || !v.available) { renderPanel(); return; }
    if (cur.mode === 'buy') { closePanel(); buyNow(v, cur.p); return; }
    closePanel();
    addToCart(v, null).catch(function (err) { toast(esc((err && err.message) || 'L’ajout n’a pas abouti. Veuillez réessayer.')); });
  }

  /* ---------- clics ---------- */
  function onAct(btn, mode) {
    var row = btn.closest('[data-ecca]'), h = row.getAttribute('data-handle');
    btn.setAttribute('aria-busy', 'true');
    getProduct(h).then(function (p) {
      btn.removeAttribute('aria-busy');
      if (!p.available) { toast('Ce produit est épuisé.'); return; }
      var pre = preselect(p, row), v = variantFor(p, pre.sel), note = '';
      if (pre.mi > -1 && pre.sel[pre.mi] == null && storedModel()) {
        var lbl = W.ECModel && W.ECModel.read() ? W.ECModel.read().label : '';
        note = 'Cette coque n’existe pas encore pour votre ' + (lbl || 'iPhone') + '. Choisissez un autre modèle uniquement s’il s’agit bien de votre téléphone.';
      }
      if (v && v.available) {
        if (mode === 'buy') { buyNow(v, p); return; }
        addToCart(v, btn).catch(function () { openPanel(p, pre, btn, '', mode); });
      } else {
        openPanel(p, pre, btn, note, mode);
      }
    }).catch(function () { btn.removeAttribute('aria-busy'); location.href = row.getAttribute('data-url') || (ROOT + 'products/' + h); });
  }
  /* phase de capture : les boutons agissent seuls, sans ouvrir la fiche ni déclencher la carte */
  d.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    var b = t.closest('[data-ecca-add],[data-ecca-buy]'); if (!b) { return; }
    e.preventDefault(); e.stopPropagation();
    if (b.disabled || b.getAttribute('aria-busy') === 'true') { return; }
    onAct(b, b.hasAttribute('data-ecca-buy') ? 'buy' : 'add');
  }, true);
  /* précharge la fiche au premier contact pour une action instantanée */
  d.addEventListener('pointerdown', function (e) { var b = e.target && e.target.closest && e.target.closest('[data-ecca-add],[data-ecca-buy]'); if (b) { getProduct(b.closest('[data-ecca]').getAttribute('data-handle')).catch(function () {}); } }, { passive: true });

  function boot() {
    decorate();
    var main = d.getElementById('MainContent') || d.body, t = 0;
    if (W.MutationObserver) { new MutationObserver(function () { W.clearTimeout(t); t = W.setTimeout(decorate, 120); }).observe(main, { childList: true, subtree: true }); }
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  d.addEventListener('shopify:section:load', function () { W.setTimeout(decorate, 60); });
  W.ECCardActions = { decorate: decorate };
})();
